export function isMemberMenuLinkActive(href: string): boolean {
    // remove last slash to avoid false negative
    const lastSlash = /\/$/
    const pathname = window.location.pathname.replace(lastSlash, '')
    const menuLink = href.replace(lastSlash, '')
    return pathname === menuLink
}
